<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-alert
        type="info"
        show-icon
        style="margin-bottom: 16px"
        message="平台消息说明"
        description="向 App 用户发送平台运营消息。系统消息由兑换、提现等业务自动推送，不在此发布。发送给全部用户时将为每位用户单独创建一条消息，已读状态互不影响。"
      />

      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-form-item label="用户ID">
            <a-input-number v-model="queryParam.userId" :min="1" placeholder="筛选用户" style="width:140px" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
            <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
            <a-button type="primary" style="margin-left: 16px" @click="handlePublish"><a-icon type="plus" />发布消息</a-button>
          </a-form-item>
        </a-form>
      </div>

      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false" :scroll="{ x: 1000 }">
        <span slot="content" slot-scope="text">
          <span class="content-cell">{{ text }}</span>
        </span>
        <span slot="isRead" slot-scope="text">
          <a-tag v-if="text === 1" color="default">已读</a-tag>
          <a-tag v-else color="green">未读</a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)">删除</a>
        </span>
      </a-table>

      <a-pagination
        class="ant-table-pagination"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @change="changePage"
      />
    </a-card>

    <a-modal
      title="发布平台消息"
      :visible="publishOpen"
      @ok="submitPublish"
      @cancel="publishOpen = false"
      :confirmLoading="publishLoading"
      width="640px"
    >
      <a-form-model :model="publishForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="标题" required>
          <a-input v-model="publishForm.title" placeholder="消息标题" />
        </a-form-model-item>
        <a-form-model-item label="内容" required>
          <a-textarea v-model="publishForm.content" :rows="5" placeholder="消息正文" />
        </a-form-model-item>
        <a-form-model-item label="发送范围" required>
          <a-radio-group v-model="publishForm.grantAll">
            <a-radio :value="true">全部正常用户</a-radio>
            <a-radio :value="false">指定用户</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="!publishForm.grantAll" label="选择用户" required>
          <app-user-multi-select v-model="publishForm.userIds" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageMessage, publishMessage, deleteMessage } from '@/api/giftcard/message'
import AppUserMultiSelect from '@/components/AppUserMultiSelect'

export default {
  name: 'GiftcardMessage',
  components: { AppUserMultiSelect },
  data() {
    return {
      loading: false,
      publishLoading: false,
      publishOpen: false,
      list: [],
      total: 0,
      queryParam: { pageNum: 1, pageSize: 10, userId: undefined },
      publishForm: {
        title: '',
        content: '',
        grantAll: true,
        userIds: []
      },
      columns: [
        { title: 'ID', dataIndex: 'id', width: 70 },
        { title: '用户ID', dataIndex: 'userId', width: 90 },
        { title: '标题', dataIndex: 'title', width: 180, ellipsis: true },
        { title: '内容', dataIndex: 'content', scopedSlots: { customRender: 'content' }, width: 300 },
        { title: '状态', dataIndex: 'isRead', scopedSlots: { customRender: 'isRead' }, width: 80 },
        { title: '发送时间', dataIndex: 'createTime', width: 170 },
        { title: '操作', scopedSlots: { customRender: 'operation' }, width: 80, fixed: 'right' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      const params = { ...this.queryParam }
      if (!params.userId) delete params.userId
      pageMessage(params).then(res => {
        this.list = res.data.records || []
        this.total = res.data.total || 0
      }).finally(() => { this.loading = false })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { pageNum: 1, pageSize: 10, userId: undefined }
      this.getList()
    },
    changePage(page, pageSize) {
      this.queryParam.pageNum = page
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    handlePublish() {
      this.publishForm = {
        title: '',
        content: '',
        grantAll: true,
        userIds: []
      }
      this.publishOpen = true
    },
    submitPublish() {
      if (!this.publishForm.title || !this.publishForm.title.trim()) {
        this.$message.warning('请输入标题')
        return
      }
      if (!this.publishForm.content || !this.publishForm.content.trim()) {
        this.$message.warning('请输入内容')
        return
      }
      const payload = {
        title: this.publishForm.title.trim(),
        content: this.publishForm.content.trim(),
        grantAll: this.publishForm.grantAll
      }
      if (!this.publishForm.grantAll) {
        const userIds = this.publishForm.userIds || []
        if (userIds.length === 0) {
          this.$message.warning('请至少选择一个用户')
          return
        }
        if (userIds.length === 1) {
          payload.userId = userIds[0]
        } else {
          payload.userIds = userIds
        }
      }
      const doPublish = () => {
        this.publishLoading = true
        publishMessage(payload).then(res => {
          const data = res.data || {}
          this.$message.success(
            `发送完成：目标 ${data.targetCount || 0} 人，成功 ${data.publishedCount || 0} 人，跳过 ${data.skippedCount || 0} 人`
          )
          this.publishOpen = false
          this.getList()
        }).finally(() => { this.publishLoading = false })
      }
      if (this.publishForm.grantAll) {
        this.$confirm({
          title: '确认发送给全部正常用户？',
          content: '将向所有状态正常的 App 用户各发送一条平台消息。',
          onOk: doPublish
        })
      } else {
        doPublish()
      }
    },
    handleDelete(record) {
      const self = this
      this.$confirm({
        title: '确认删除该消息？',
        onOk() {
          return deleteMessage(record.id).then(() => {
            self.$message.success('删除成功')
            self.getList()
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.content-cell {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 280px;
}
</style>
